// extracted by mini-css-extract-plugin
module.exports = {"formControl":"DateRangeSelect_formControl__ZW11Z","root":"DateRangeSelect_root__qIlYZ"};